<template>
    <div v-if="page==1" class="panel page1">
        <div class="head">
            <h1>灵签</h1>
        </div>
        <div class="content">
            <my-button class="button" @click="()=>onchange(2)">关帝灵签</my-button>
            <my-button class="button" @click="()=>onchange(3)">观音灵签</my-button>
        </div>
        <div class="foot"></div>
    </div>
    <div v-if="page==2" class="panel page2" style="">
        <div class="content">
            <template v-if="type==3">
                <my-transition/>
                <guan-yin></guan-yin>
            </template>
            <template v-if="type==2">
                <my-transition/>
                <guan-yu></guan-yu>
            </template>
        </div>
        <div class="foot">
            <my-button class="btn-style2 home-btn" @click="page=1">返回</my-button>
            <!--<my-button class="button" :press="type==1" @click="()=>onchange(1)">每日一签</my-button>-->
            <!--<my-button class="button" :press="type==2" @click="()=>onchange(2)">关帝灵签</my-button>-->
            <!--<my-button class="button" :press="type==3" @click="()=>onchange(3)">观音灵签</my-button>-->
        </div>
    </div>
</template>

<script>
    import { reactive, toRefs } from 'vue'
    import { data0, data3, data2 } from '@/assets/data1'
    import MyButton from '@/components/Button'
    import PortraitPlay from '@/components/portraits/portrait_play'
    import PortraitGuanyin from '@/components/portraits/portrait_guanyin'
    import PortraitGuangon from '@/components/portraits/portrait_guangon'
    import GuanYin from '@/views/TempleHall/GuanYin/index'
    import GuanYu from '@/views/TempleHall/GuanYu/index'
    import MyTransition from '@/components/transition/index'

    export default {
        name: 'Home',
        props: {},
        components: {
            MyButton,
            PortraitPlay,
            PortraitGuanyin,
            PortraitGuangon,
            GuanYin,
            GuanYu,
            MyTransition,
        },
        setup: () => {
            const state = reactive({
                page: 1,
                type: 3,
                onchange: (type) => {
                    state.type = type
                    state.page = 2
                    console.log('onchange')
                },
            })

            return { ...toRefs(state), }
        }
    }
</script>

<style scoped lang="scss">
    .page1 {
        flex-direction: column;
        justify-content: space-between;

        .head {
            text-align: center;
            height: 60px;
        }
        .foot {
            height: 60px;
        }
        .content {
            flex: 1 1 auto;
            justify-content: center;
            align-items: center;
        }

        .button {
            width: 200px;
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            margin-bottom: 16px;
        }
    }

    .page2 {
        flex-direction: column;
        flex: 1 1 auto;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex: 1 1;
        flex-direction: column;
        overflow: hidden;
        position: relative;
    }

    .panel {
        display: flex;
        flex: 1 0 auto;

        background-image: url("~@/assets/jiao.png"),
        url("~@/assets/jiao.png"),
        url("~@/assets/jiao.png"),
        url("~@/assets/jiao.png"),
        url("~@/assets/jiao.png"),
        url("~@/assets/jiao.png"),
        url("~@/assets/bian-y.png"),
        url("~@/assets/bian-x.png"),
        url("~@/assets/bian-y.png"),
        url("~@/assets/bian-x.png");
        background-repeat: no-repeat,no-repeat,no-repeat,no-repeat,no-repeat,no-repeat,repeat-y,repeat-x,repeat-y,repeat-x;
        background-size: 60px 60px,60px 60px,60px 60px,60px 60px,60px 60px,60px 60px,9px 11px,11px 9px,9px 11px,11px 9px;
        /*background-position: left top, right top, left bottom, right bottom;*/
        background-position: -30px -30px,
        calc(100% + 30px) -30px,
        -30px calc(100% + 30px),
        calc(100% + 30px) calc(100% + 30px),
        -45px,
        calc(100% + 45px),
        left,top,right,bottom;

        /*border: 8px double #ccc;*/
    }

    .foot {
        display: flex;
        padding: 16px;
        justify-content: space-around;
    }

    .home-btn {
        position: absolute;
        right: 16px;
        bottom: 16px;
    }
</style>